import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import VideoCard from './VideoCard';
import SafeIcon from '../common/SafeIcon';
import { getTrainingRowListPath } from '../../constants/training';

export default function VideoRow({ title, sessions, isComingSoon = false, rowId }) {
  const navigate = useNavigate();
  const scrollRef = useRef(null);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const { scrollLeft, clientWidth } = scrollRef.current;
      const scrollTo = direction === 'left' ? scrollLeft - clientWidth + 100 : scrollLeft + clientWidth - 100;
      scrollRef.current.scrollTo({ left: scrollTo, behavior: 'smooth' });
    }
  };

  return (
    <div className="mb-8 relative group/row">
      <div className="flex items-center justify-between mb-4 px-4 md:px-8">
        <h2 className="text-lg md:text-xl font-black text-[var(--text-main)] tracking-tight uppercase italic italic">{title}</h2>
        <button
          type="button"
          onClick={() => rowId && navigate(getTrainingRowListPath(rowId))}
          disabled={!rowId}
          className="text-[10px] font-black uppercase tracking-[0.2em] text-brand-cyan hover:text-brand-green flex items-center gap-1 transition-colors disabled:opacity-40 disabled:pointer-events-none"
        >
          Ver todo <SafeIcon name="ChevronRight" className="w-4 h-4" />
        </button>
      </div>
      
      <div className="relative">
        <button 
          onClick={() => scroll('left')}
          className="hidden md:flex absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 z-10 w-10 h-10 bg-[var(--bg-surface)] border border-[var(--border-subtle)] text-[var(--text-main)] rounded-full items-center justify-center backdrop-blur-sm shadow-lg opacity-0 group-hover/row:opacity-100 transition-all transform hover:scale-110"
        >
          <SafeIcon name="ChevronLeft" className="w-6 h-6" />
        </button>

        <div 
          ref={scrollRef}
          className="flex gap-4 overflow-x-auto px-4 md:px-8 pb-4 hide-scrollbar snap-x snap-mandatory"
        >
          {isComingSoon && sessions.length === 0 ? (
            <div className="snap-start flex-shrink-0 w-64 md:w-72">
              <div className="aspect-video rounded-xl border-2 border-dashed border-[var(--border-subtle)] bg-[var(--bg-surface)] flex flex-col items-center justify-center gap-3 px-6 text-center">
                <SafeIcon name="Clock" className="w-8 h-8 text-[var(--text-secondary)]/50" />
                <span className="text-[10px] font-black uppercase tracking-[0.2em] text-[var(--text-secondary)]">
                  Próximamente
                </span>
              </div>
            </div>
          ) : (
            sessions.map((session) => (
              <div key={session.id} className="snap-start">
                <VideoCard session={session} />
              </div>
            ))
          )}
        </div>

        <button 
          onClick={() => scroll('right')}
          className="hidden md:flex absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 z-10 w-10 h-10 bg-[var(--bg-surface)] border border-[var(--border-subtle)] text-[var(--text-main)] rounded-full items-center justify-center backdrop-blur-sm shadow-lg opacity-0 group-hover/row:opacity-100 transition-all transform hover:scale-110"
        >
          <SafeIcon name="ChevronRight" className="w-6 h-6" />
        </button>
      </div>
    </div>
  );
}